import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 font-bold text-lg font-heading">97</span>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">97影视</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              97影视致力于为广大影迷提供高清免费在线观影服务，海量电影电视剧全集免费看，流畅不卡顿秒播无广告，为您打造极速观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-bold mb-4 font-heading text-base">影视分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-bold mb-4 font-heading text-base">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页推荐</Link></li>
              <li><Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门剧集</Link></li>
              <li><Link to="/category/anime" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动漫番剧</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-bold mb-4 font-heading text-base">免责声明</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站所有内容均来自互联网分享，仅供学习和交流使用。如侵犯您的权益，请及时联系我们进行处理。本站不存储任何影视资源文件。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 97影视 - 高清免费在线观看。All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            <Link to="/about" className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}